import * as angular from 'angular';

import { IValueViewModel, Group, ComponentDefinition } from '../../../models';

class IdentifierUsageModalController implements angular.IComponentController {
    hasUsage: boolean;
    item: IValueViewModel;
    modalId: string;

    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['item']) {
            let item = changesObj['item'].currentValue;
            const previousItem = changesObj['item'].previousValue;
            if (item === null && previousItem !== null) {
                item = previousItem;
                this.item = item;
            }
            this.hasUsage = this.item?.canDelete ?? false;
        }
    }
}

export const wtIdentifierUsageModal: ComponentDefinition = {
    componentId: 'wtIdentifierUsageModal',
    controller: IdentifierUsageModalController,
    template: require('./identifierUsageModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '<',
        modalId: '@'
    }
};